angular.module('impactx.catalog').service("DefaultPicture", DefaultPicture);
DefaultPicture.$inject = ['$mdDialog'];

function DefaultPicture($mdDialog) {

    function showDefaultPictureDialog(catId, productIds, event) {
        return $mdDialog.show({
            templateUrl: 'modules/catalog/templates/default-picture-dialog.tmpl.html',
            locals: {catId: catId, proIds: productIds},
            controller: 'DefaultPictureDialogCtrl',
            controllerAs: 'defaultPictureDialogCtrl',
            parent: angular.element(document.body),
            targetEvent: event,
            bindToController: true,
            clickOutsideToClose: false,
        });
    }

    return {
        showDefaultPictureDialog: showDefaultPictureDialog
    };
}